import {mergeToHierarchy} from '#core/utils/config-utils.js';
import {SpriteMapStorage} from '#core/utils/spritemap-storage/index.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {sportsPagesFactory} from './sport-page.factory.js';
import {getMatchSportsDefaultPagePriority} from './utils.js';

import PALETTE_SCHEMA from './sport-page.palette-schema.yaml';
import SCHEMA from './sport-page.schema.yaml';

class SportPagesFeature extends AbstractVisualFeature {
    get name() {
        return 'Sport Page';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return sportsPagesFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const {matchSportLandingPage} = this.config;
        const sportsDefaultPagePriority = getMatchSportsDefaultPagePriority(
            matchSportLandingPage.default,
            matchSportLandingPage.sports
        );

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            SportDefaultPage: {
                sports: sportsDefaultPagePriority,
            },
            SportIcons: {
                defaultIcon: 'default',
                ...SpriteMapStorage.sportIdToSpritesMapping,
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

new SportPagesFeature(SportsContent);
